import { useState } from "react";
import type { Space } from "@scenix/core";
import { api } from "../lib/api";
import { initials } from "./AccountMenu";

/**
 * A space's logo, or its initials when it has none.
 *
 * Used in three places (the header badge, the spaces list, the space page),
 * so the broken-image fallback lives here once rather than three times.
 */
export function SpaceAvatar({
  space,
  size = 24,
}: {
  space: Pick<Space, "id" | "name" | "logoPath">;
  size?: number;
}) {
  const [broken, setBroken] = useState(false);

  if (space.logoPath && !broken) {
    return (
      <img
        src={api.spaceLogoUrl(space.id)}
        alt=""
        width={size}
        height={size}
        className="space-avatar"
        onError={() => setBroken(true)}
      />
    );
  }

  return (
    <span
      className="space-avatar space-avatar--initials"
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      {initials(space.name)}
    </span>
  );
}
